"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcuantResultEnumToJSON = exports.AcuantResultEnumFromJSONTyped = exports.AcuantResultEnumFromJSON = exports.AcuantResultEnum = void 0;
/**
 * The Result of an Acuant scan; can be used at the document level and for alerts. These map to the numeric results
 * -1 through 6 in the Acuant payload.
 * @export
 * @enum {string}
 */
var AcuantResultEnum;
(function (AcuantResultEnum) {
    AcuantResultEnum["Unknown"] = "Unknown";
    AcuantResultEnum["Passed"] = "Passed";
    AcuantResultEnum["Failed"] = "Failed";
    AcuantResultEnum["Skipped"] = "Skipped";
    AcuantResultEnum["Caution"] = "Caution";
    AcuantResultEnum["Attention"] = "Attention";
    AcuantResultEnum["INVALIDVALUE"] = "_INVALID_VALUE";
})(AcuantResultEnum = exports.AcuantResultEnum || (exports.AcuantResultEnum = {}));
function AcuantResultEnumFromJSON(json) {
    return AcuantResultEnumFromJSONTyped(json, false);
}
exports.AcuantResultEnumFromJSON = AcuantResultEnumFromJSON;
function AcuantResultEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AcuantResultEnumFromJSONTyped = AcuantResultEnumFromJSONTyped;
function AcuantResultEnumToJSON(value) {
    return value;
}
exports.AcuantResultEnumToJSON = AcuantResultEnumToJSON;
//# sourceMappingURL=AcuantResultEnum.js.map